export default "__VITE_ASSET__CJWGfHJG__"